import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "./app";
import api from "./api";
import API_URL from "../config/ApiUrl";

const NumberManagementNumberAttributesReportSlice = createSlice({
  name: "NumberManagementNumberAttributesReportSlice",
  initialState: {},
  reducers: {},
});

export const addNumberManagementNumberAttributesReport =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const {
        from_date = "",
        to_date,
        number_type,
        limit,
        offset,
      } = payload || {};

      // Ensure `request_id` is included in the payload
      const requestBody: any = {
        from_date,
        to_date,
        number_type,
        page_size: limit,
        current: offset,
      };

      // Make the API request with the constructed body
      const res = await api.post(
        API_URL.NUMBER_ATTRIBUTES_REPORTS.ADD,
        requestBody
      );
      return Promise.resolve(res.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const fetchListNumberManagementNumberAttributesReports =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      // Destructure payload with default values
      const {
        from_date = "",
        to_date = "",
        number_type = "",
        current = 1,
        page_size = 10,
      } = payload || {};

      // Construct the query string dynamically
      const actionParts = [
        `from_date=${from_date}`,
        `to_date=${to_date}`,
        `number_type=${number_type}`,
        `current=${current}`,
        `page_size=${page_size}`,
      ];

      // Join query parts
      const action = `?${actionParts.join("&")}`;

      // Make the API call
      const response = await api.get(
        API_URL.NUMBER_ATTRIBUTES_REPORTS.LIST + action
      );

      // Return the response data
      return Promise.resolve(response?.data?.data);
    } catch (error: any) {
      // Improved error handling
      return Promise.reject(error?.response?.data || error.message);
    }
  };

export const deleteNumberManagementNumberAttributesReport =
  (payload?: any): AppThunk<any> =>
  async (dispatch) => {
    try {
      const response = await api.post(
        API_URL.NUMBER_ATTRIBUTES_REPORTS.DELETE,
        payload
      );
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export default NumberManagementNumberAttributesReportSlice.reducer;
